module.exports = __webpack_public_path__ + "static/media/video-thumbnail.e19ec79a.png";